// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 2579 ? "theda" : chunkId) + "." + {"2579":"0863a057","3630":"4b058fd6","7873":"24565726"}[chunkId] + ".chunk.css";
};